import './custom-select.scss';

export class CustomSelect {
  #selector;

  constructor(selector) {
    const _self = this;
    this.#selector = selector;
    let x, j, ll, selectedItem, itemList, type;
    /* Look for any elements with the class "form-select": */
    x = document.querySelectorAll(this.#selector);

    x.forEach((container) => {
      let selElmnt = container.getElementsByTagName('select')[0];

      /* For each element, create a new DIV that will act as the selected item: */
      selectedItem = document.createElement('div');
      selectedItem.setAttribute('class', 'select-selected');
      selectedItem.setAttribute('tabindex', '0');

      for (let index in selElmnt.options) {
        const option = selElmnt.options[index];

        if (option.value !== undefined && option.selected) {
          selectedItem.innerHTML = option.innerHTML;
        }

        if (option.value !== undefined && index === '0') {
          selectedItem.innerHTML = option.innerHTML;
        }
      }

      const select = container.querySelector('select');
      select.insertAdjacentElement('afterend', selectedItem);

      /* For each element, create a new DIV that will contain the option list: */
      itemList = document.createElement('div');
      itemList.setAttribute('class', 'select-items select-hide');

      if (selElmnt.getElementsByTagName('optgroup').length > 0) {
        type = 'optgroup';
        ll = selElmnt.getElementsByTagName('optgroup').length;
        for (j = 0; j < ll; j++) {
          this.createOptions(selElmnt.getElementsByTagName('optgroup')[j], type, itemList);
        }
      } else {
        type = 'option';
        ll = selElmnt.options.length;
        this.createOptions(selElmnt.options, type, itemList);

      }

      container.querySelector('.select-selected').insertAdjacentElement('afterend', itemList);

      selectedItem.addEventListener('click', function (e) {
        /* When the select box is clicked, close any other select boxes,
        and open/close the current select box: */
        e.preventDefault();
        e.stopPropagation();
        _self.closeAllSelect(this);
        this.nextSibling.classList.toggle('select-hide');
        this.classList.toggle('select-arrow-active');
      });

      selectedItem.addEventListener('keydown', function (e) {
        if (e.key == ' ' || e.code == 'Space' || e.code == 'Enter') {
          e.preventDefault();
          e.stopPropagation();
          _self.closeAllSelect(this);
          this.nextSibling.classList.toggle('select-hide');
          this.classList.toggle('select-arrow-active');
        }
      });
    });

    /* If the user clicks anywhere outside the select box,
    then close all select boxes: */
    document.addEventListener('click', _self.closeAllSelect);
  }

  createGroupOptions(setElmnt, type, itemList) {
    let label = null, labelContainer = null, groupOption;

    if (type == 'optgroup') {
      groupOption = setElmnt.children;
      labelContainer = document.createElement('div');
      labelContainer.classList.add('custom-select__title');
      label = document.createElement('h2');

      label.innerHTML = setElmnt.label;
      labelContainer.appendChild(label);
      itemList.appendChild(labelContainer);
    } else {
      groupOption = setElmnt;
    }

    return groupOption;
  }

  updateCustomSelect(event) {
    /* When an item is clicked, update the original select box,
          and the selected item: */

    const selected = event.target;

    let y, i, k, s, h, sl, yl;
    s = selected.parentNode.parentNode.getElementsByTagName('select')[0];
    sl = s.length;
    h = selected.parentNode.previousSibling;

    for (i = 0; i < sl; i++) {
      if (s.options[i].innerHTML == selected.innerHTML) {
        s.selectedIndex = i;
        h.innerHTML = this.innerHTML;
        y = selected.parentNode.parentNode.getElementsByClassName('item__selected');
        yl = y.length;
        for (k = 0; k < yl; k++) {
          y[k].classList.remove('item__selected');
        }
        selected.classList.add('item__selected');
        break;
      }
    }
  }

  createOptions(setElmnt, type, itemList) {

    /* For each option in the original select element,
    create a new DIV that will act as an option item: */
    const groupOption = this.createGroupOptions(setElmnt, type, itemList);

    for (let index in groupOption) {
      const option = groupOption[index];
      if (typeof option === 'object') {

        const item = document.createElement('div');
        item.classList.add('item');
        item.innerHTML = option.innerHTML;

        item.addEventListener('click', this.updateCustomSelect);

        itemList.appendChild(item);
      }
    }
  }

  closeAllSelect(elmnt) {
    /* A function that will close all select boxes in the document,
    except the current select box: */
    let x, y, i, xl, yl, arrNo = [];
    x = document.getElementsByClassName('select-items');
    y = document.getElementsByClassName('select-selected');
    xl = x.length;
    yl = y.length;

    for (i = 0; i < yl; i++) {
      if (elmnt == y[i]) {
        arrNo.push(i)
      } else {
        y[i].classList.remove('select-arrow-active');
      }
    }

    for (i = 0; i < xl; i++) {
      if (arrNo.indexOf(i)) {
        x[i].classList.add('select-hide');
      }
    }
  }
}

window.addEventListener('load', function () {
  if (document.querySelectorAll('.form-type-select')) {
    const customSelect = new CustomSelect('.form-type-select');
  }
});

